import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=29b15d64&"
import script from "./NotificationBell.vue?vue&type=script&lang=ts&"
export * from "./NotificationBell.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports